/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import type ZendeskMessagingDataController from 'embercom/controllers/apps/app/standalone/deploy/zendesk/messaging/data';

export default class ZendeskMessagingDataRoute extends Route {
  queryParams = {
    section: {
      refreshModel: false,
    },
  };

  setupController(
    controller: ZendeskMessagingDataController,
    model: unknown,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);
    controller.set('section', null);
  }
}
